module.exports = __webpack_public_path__ + "img/ic_capterra.6c39e82b.svg";